class ProductTabs extends HTMLElement {
	connectedCallback() {
		this.buttons = Array.from(this.querySelectorAll('button[aria-controls]'));
		this.buttons.forEach((button) => button.addEventListener('click', () => this.selectButton(button)));
	}

	get selectedButton() {
		return this.buttons.find((button) => button.getAttribute('aria-expanded') === 'true');
	}
	selectButton(button) {
		if (!this.buttons.includes(button) || this.selectedButton === button) {
			return;
		}
		const from = document.getElementById(this.selectedButton.getAttribute('aria-controls'));
		const to = document.getElementById(button.getAttribute('aria-controls'));

		from.hidden = true;
		to.hidden = false;
		button?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
		this.selectedButton.setAttribute('aria-expanded', 'false');
		button.setAttribute('aria-expanded', 'true');
	}
}
window.customElements.define('product-tabs', ProductTabs);

document.addEventListener('DOMContentLoaded', () => {
	const reviewsIoStars = document.querySelector('.ruk_rating_snippet');
	// const reviewsIoTab = document.querySelector('[reviews-io-tab]');
	const reviewsIoCarousel = document.querySelector('reviewsio-card-carousel');
	if (reviewsIoStars && reviewsIoCarousel) {
		reviewsIoStars?.addEventListener('click', () => {
			const targetPosition = reviewsIoCarousel?.getBoundingClientRect().top;
			const stickyHeader = document.querySelector('#SiteHeader');
			const headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;
			window.scrollTo({ top: targetPosition - headerOffset, behavior: 'smooth' });
		});
	}
});
